import React, { ReactElement, useState } from 'react';
import './funkcionalitaAdministratoraButton.scss';
import Dropdown from '../../../../Dropdown/Dropdown';
import LegislativnyMaterialDetail from '../../../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import FunkcionalitaAdministratora from './FunkcionalitaAdministratora';
import PracovnyKrokListRequest from '../../../../../model/pracovnyKrok/PracovnyKrokListRequest';
import { ClientStatus } from '../../../../../model/ClientStatus';

interface Props {
  material: LegislativnyMaterialDetail;
  reloadMaterial: () => void;
  pracovneKrokyRequest: PracovnyKrokListRequest;
  pracovneKrokyStatus: ClientStatus;
  reloadPracovneKroky
}

const FunkcionalitaAdministratoraButton = ({
  material,
  reloadMaterial,
  pracovneKrokyRequest,
  pracovneKrokyStatus,
  reloadPracovneKroky,
}: Props): ReactElement => {
  const [isDropdownOpened, setIsDropdownOpened] = useState<boolean>(false);
  return (
    <div className="material-detail-admin-funkcionalita__button">
      <Dropdown
        title="Funkcionalita administrátora"
        loading={pracovneKrokyStatus?.loading}
        isDropdownOpened={isDropdownOpened}
        setIsDropdownOpened={setIsDropdownOpened}
      >
        <FunkcionalitaAdministratora
          legMaterial={material}
          pracovneKroky={pracovneKrokyRequest}
          reloadPracovneKroky={reloadPracovneKroky}
          reloadDetail={reloadMaterial}
          setIsDropdownOpened={setIsDropdownOpened}
        />
      </Dropdown>
    </div>
  );
};

export default FunkcionalitaAdministratoraButton;
